export const ADD_PLANT_START = "ADD_PLANT_START";
export const ADD_PLANT_SUCCESS = "ADD_PLANT_SUCCESS";
export const ADD_PLANT_FAIL = "ADD_PLANT_FAIL";

export const ADD_PLANT_SHOW_MODAL = "ADD_PLANT_SHOW_MODAL";
export const ADD_PLANT_HIDE_MODAL = "ADD_PLANT_HIDE_MODAL";
